{
  "loading": "Chargement...",
  "placeholder": "Sélectionner…"
}
